export default (valor) => {
    if (!valor) return '-'

    const cnpjCpf = valor.replace(/\D/g, '')
    if (cnpjCpf.length === 11) return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4') //NOSONAR
    if (cnpjCpf.length === 14) return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5') //NOSONAR
    return valor
}

